import { useEffect, useContext, useState } from 'react';
import { Box, FlosIcon, ResourceContext } from '@flos/react-ui';
import useAppState from '../../state/appState';
import { LandingPage as LandingPageType, FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';

const LandingPage = ({ elementId, caption, values }: LandingPageType) => {
    const formConfig = useAppState((state) => state.formConfig);
    const [responseTime, setResponseTime] = useState<string>('');

    const labels = useContext(ResourceContext);

    useEffect(() => {
        // the expected response time can be edited and fetched from the CMS at:
        // dk-sites->administration->labels->Hybrid APPs->Skade->Skade anmeldelse->Claim response time
        if (formConfig?.useCmsTexts) {
            setResponseTime(labels(`response.time.${formConfig?.automation.receiptEmail}`));
        }
    }, [formConfig, labels]);

    return (
        <div className="u-spacing-stack-s">
            <Box className="u-spacing-inset-l">
                <h4>{caption}</h4>
                <ul className="List List--icons landingpage-list">
                    {values.map((item) => (
                        <li key={`${item.icon}-${item.caption}`}>
                            <FlosIcon className="is-indigo" shape={item.icon} size={32} />
                            {item.caption.replace('{response.time}', responseTime)}
                        </li>
                    ))}
                </ul>
            </Box>
        </div>
    );
};

LandingPage.isValid = (formConfig: FormConfig, formValues: FormValues, elementId: string): boolean => {
    return true;
};

export default LandingPage;
